<template>
  <div id="app">
    <div class="container">
      <h1 style="font-weight: 100; font-size: 22px; color: lightslategray; letter-spacing: 5px">Please sign here</h1>
      <vue-signature-pad
          id="signature"
          :width="width"
          :height="height"
          ref="signaturePad"
          :options="options"
      />
      <div class="buttons">
        <button class="styled-button btn btn-outline-primary" @click="save">
          Confirm
          <span></span>
        </button>

        <button class="styled-button" @click="undo">
          Undo
          <span></span>
        </button>

        <button class="styled-button" @click="clear">
          Clear
          <span></span>
        </button>
      </div>
    </div>

    <!-- Overlay -->
    <div v-if="submitting" class="overlay">
      <div class="spinner"></div>
      <p>Submitting data, please wait...</p>
    </div>

  </div>
</template>

<script>
import { VueSignaturePad } from 'vue-signature-pad';
import { mapActions, mapGetters } from 'vuex';

//import axios from 'axios';

export default {
  name: "VueSignature",
  components: {
    VueSignaturePad
  },

  computed: {
    ...mapGetters(['getFormData'])
  },

  props: {
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: [String, Number],
      default: '200px'
    },
    initialColor: {
      type: String,
      default: "darkgreen"
    }
  },
  data() {
    return {
      submitting: false, // Track submission state
      options: {
        penColor: this.initialColor
      },
      formData: {},
    };
  },
  methods: {
    ...mapActions(['setFormData', 'submitFormData']),
    async save() {
      if (this.$refs.signaturePad) {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        if (!isEmpty) {
          this.setFormData({ signature: data });

          this.submitting = true; // Show the overlay

          try {
            await this.submitFormData();
            this.$swal({
              title: 'Booked!',
              text: 'Your date has been booked.',
              icon: 'success',
              confirmButtonText: 'OK',
            });
            this.$router.push({ name: 'SuccessPage', query: { invoiceNumber: this.invoiceNumber } });

            // Clear the signature pad and form data after success
            this.clear();
            this.setFormData({
              invoiceNumber: '',
              installationDate: '',
              goingLiveDate: '',
              additionalNotes: '',
              power: false,
              internet: false,
              hardware: false,
              //stockList: false,
              //employeeList: '',
              stockList: '',
              employeeList: '',
              signature: '',
            });

          } catch (error) {
            this.$swal({
              title: 'Failed to Book',
              text: error.message || 'Please try again.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          } finally {
            this.submitting = false; // Hide the overlay after submission
          }
        } else {
          this.$swal({
            title: 'No Signature',
            text: 'Please provide a signature before confirming.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
        }
      }
    },
    undo() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.undoSignature();
      }
    },
    clear() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.clearSignature();
      }
    },
  },

};
</script>

<style scoped>
#signature {
  border: double 5px transparent;
  border-radius: 15px;
  background-image: linear-gradient(aliceblue, aliceblue),
  radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  margin-top: 110px;
  width: 100%;
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
.styled-button {
  border: none;
  display: block;
  position: relative;
  padding: 0.7em 2.4em;
  font-size: 18px;
  background: transparent;
  cursor: pointer;
  user-select: none;
  overflow: hidden;
  color: royalblue;
  z-index: 1;
  font-family: inherit;
  font-weight: 500;
}

.styled-button span {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: -1;
  border: 4px solid royalblue;
}

.styled-button span::before {
  content: "";
  display: block;
  position: absolute;
  width: 8%;
  height: 500%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-60deg);
  transition: all 0.3s;
}

.styled-button:hover span::before {
  transform: translate(-50%, -50%) rotate(-90deg);
  width: 100%;
  background: royalblue;
}

.styled-button:hover {
  color: white;
}

.styled-button:active span::before {
  background: #2751cd;
}

@media (max-width: 768px) {
  #signature {
    height: 300px;
  }
  .styled-button {
    padding: 0.4em 1.2em;
    font-size: 12px;
  }

  .container {
    margin-top: 150px;
  }
}

/* Overlay styles */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 4px solid white;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
